<footer class="footer" style="z-index: 9;display: flex; width: 100%;">
    <div class="container-fluid" style="display: flex; justify-content: space-between; width: 100%;">
        <nav class="pull-left">
            <ul>
                <li>
                    <a href="https://www.polen.com.br" target="_blank">
                        Polen
                    </a>
                </li>
                <li>
                    <a href="http://blog.polen.com.br" target="_blank">
                        Blog
                    </a>
                </li>
                <li>
                    <a href="https://www.polen.com.br/faq" target="_blank">
                        FAQ
                    </a>
                </li>
                <!-- <li>
                    <a href="http://www.creative-tim.com/license">
                        Licenses
                    </a>
                </li> -->
            </ul>
        </nav>
        <div class="copyright pull-right">
            &copy; {{test | date: 'yyyy'}}, feito com <i class="fa fa-heart heart"></i> pelo <a
                href="https://www.polen.com.br" target="_blank">Polen</a>
        </div>
    </div>
</footer>